import React from "react";
import PropTypes from "prop-types";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";

const DatePicker = React.forwardRef((props, ref) => {
  return (
    <FormGroup>
      <FormLabel>{props.label}</FormLabel>
      <FormControl onChange={props.onChange} ref={ref} type="date"></FormControl>
    </FormGroup>
  );
});

DatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default DatePicker;
